import { render, staticRenderFns } from "./AdvancedEditor.vue?vue&type=template&id=35ee0152&scoped=true"
import script from "./AdvancedEditor.vue?vue&type=script&lang=js"
export * from "./AdvancedEditor.vue?vue&type=script&lang=js"
import style0 from "./AdvancedEditor.vue?vue&type=style&index=0&id=35ee0152&prod&lang=scss"
import style1 from "./AdvancedEditor.vue?vue&type=style&index=1&id=35ee0152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee0152",
  null
  
)

export default component.exports